import { render, staticRenderFns } from "./OrderStatusChange.vue?vue&type=template&id=3358eca4&scoped=true&"
import script from "./OrderStatusChange.vue?vue&type=script&lang=js&"
export * from "./OrderStatusChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3358eca4",
  null
  
)

export default component.exports